export const ARTISAN_PRODUCT_LIST_REQUEST = "ARTISAN_PRODUCT_LIST_REQUEST";
export const ARTISAN_PRODUCT_LIST_SUCCESS = "ARTISAN_PRODUCT_LIST_SUCCESS";
export const ARTISAN_PRODUCT_LIST_FAIL = "ARTISAN_PRODUCT_LIST_FAIL";

export const ARTISAN_PRODUCT_DETAILS_REQUEST = "ARTISAN_PRODUCT_DETAILS_REQUEST";
export const ARTISAN_PRODUCT_DETAILS_SUCCESS = "ARTISAN_PRODUCT_DETAILS_SUCCESS";
export const ARTISAN_PRODUCT_DETAILS_FAIL = "ARTISAN_PRODUCT_DETAILS_FAIL";

export const ARTISAN_PRODUCT_DELETE_REQUEST = "ARTISAN_PRODUCT_DELETE_REQUEST";
export const ARTISAN_PRODUCT_DELETE_SUCCESS = "ARTISAN_PRODUCT_DELETE_SUCCESS";
export const ARTISAN_PRODUCT_DELETE_FAIL = "ARTISAN_PRODUCT_DELETE_FAIL";

export const ARTISAN_PRODUCT_CREATE_REQUEST = 'ARTISAN_PRODUCT_CREATE_REQUEST'
export const ARTISAN_PRODUCT_CREATE_SUCCESS = 'ARTISAN_PRODUCT_CREATE_SUCCESS'
export const ARTISAN_PRODUCT_CREATE_FAIL = 'ARTISAN_PRODUCT_CREATE_FAIL'
export const ARTISAN_PRODUCT_CREATE_RESET = 'ARTISAN_PRODUCT_CREATE_RESET'